<div class="pr-small-x pr-small-t pr-xsmall-b">
  <fin-grouped-services
    *ngIf="filteredGroupedServices.length > 0"
    class="block pr-xsmall-b border-bottom"
    [groupedServices]="filteredGroupedServices"
  />

  <ng-container *ngIf="!hideSelection">
    <div class="flex flex--middle" [class.pr-xsmall-t]="filteredGroupedServices.length > 0">
      <div class="font-body-1 medium-type" data-testid="ancillaries-subtitle">
        {{
          (ancillaries.length > 0
            ? 'ancillaries.productList.subtitle.added'
            : isAncillaryHighlightedServicesEnabled && isHighlightedServicesAvailable
              ? 'ancillaries.productList.subtitle.topPick'
              : 'ancillaries.productList.subtitle.generic'
          ) | finLocalization
        }}
      </div>
    </div>

    <div class="flex" *ngIf="ancillaries.length">
      <div class="flex-4 align-left">
        <ul class="accommodate-icon list-disc-style">
          <li *ngFor="let ancillary of ancillaries">
            <span *ngIf="ancillary.quantity > 1">{{ ancillary.quantity }} x </span>

            <span data-testid="ancillary-selection-title">
              @if (ancillary.category === Category.SEAT_WIFI) {
                @let bundle = ancillary.bundleServiceData$ | async;
                {{
                  'ancillaries.bundle.selectionTitle.' + ancillary.category
                    | finLocalization
                      : {
                          seatType: bundle?.seatTypeLabel | finLocalization,
                          seatNumber: bundle?.seatNumber,
                          includedProduct: bundle?.includedProduct,
                        }
                    | finEmpty: ancillary.translations.title
                }}
              } @else {
                {{ ancillary.translations.title }}
              }
            </span>

            @let tierPrices = serviceToVariantTierPricesMap?.get(ancillary.variant);
            @if (tierPrices?.accumulatedOriginalPrice ?? ancillary.originalPrice; as originalPrice) {
              <span class="strike-through">{{ originalPrice | finPrice }}</span>
            }
            @if (ancillary.totalPrice && +ancillary.totalPrice?.amount !== 0) {
              <span data-testid="ancillary-variant-total-price" class="heather-700-text">{{
                tierPrices?.accumulatedPrice ?? ancillary.totalPrice | finPrice
              }}</span>
            }
          </li>
        </ul>
      </div>
      <div class="flex-1 align-right" *ngIf="showRemoveBasedOnAncillaries">
        <fcom-button
          data-testid="ancillary-selection-remove-button"
          [aria]="{ describedby: 'ancillaries-total-price' }"
          [icon]="{
            name: SvgLibraryIcon.CLOSE_DELETE,

            position: IconPosition.LEFT,
          }"
          [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
          [text]="'ancillaries.removeSelections' | finLocalization"
          (clickBtn)="removeSelections.emit($event)"
        />
      </div>
    </div>
  </ng-container>
</div>
